import Image from "next/image";
import { memo } from "react";
import twemoji from "twemoji";

interface TwemojiProps {
  emoji: string;
  ext?: "svg" | "png";
  width?: number;
  height?: number;
}

const isRequired = () => {
  throw new Error("You need to specify an emoji for the Twemoji component");
};

const U200D = String.fromCharCode(0x200d);
const UFE0Fg = /\uFE0F/g;

function Twemoji({ emoji = isRequired(), ext = "svg", width = 16, height = 16 }: TwemojiProps) {
  const hexCodePoint = twemoji.convert.toCodePoint(emoji.indexOf(U200D) < 0 ? emoji.replace(UFE0Fg, "") : emoji);

  return (
    <Image
      src={`https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/${ext === "png" ? "72x72" : "svg"}/${hexCodePoint}.${ext}`}
      width={width}
      height={height}
      alt={emoji}
      loading="lazy"
      draggable={false}
      className="inline-flex"
      style={{
        verticalAlign: "-0.125em",
      }}
    />
  );
}

export default memo(Twemoji);
